/* eslint-disable jsx-a11y/anchor-is-valid */
import PropTypes from 'prop-types';
import Link from 'next/link';
import Image from 'next/image';
import { Card, ImgContainer, Container, Title, Date, Author } from './styled';

const Post = (props) => {
  const { slug, thumbnail, title, date, author } = props;

  return (
    <Card>
      <Link href={`/blog/${slug}`}>
        <ImgContainer>
          <Image
            src={thumbnail}
            alt={title}
            fill
            style={{ objectFit: 'cover' }}
          />
        </ImgContainer>
        <Container>
          <Title>{title}</Title>
          <Date>{date}</Date>
          <Author>{author}</Author>
        </Container>
      </Link>
    </Card>
  );
};

Post.propTypes = {
  slug: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
};

export default Post;
